import { gsap } from "gsap";

export function fv() {
    // 初期状態を設定
    function setInitialState() {
        const elements = [
            '.p-fv__message-txt01-black',
            '.p-fv__message-txt01-white',
            '.p-fv__color-bar',
            '.p-fv__message-splide-box',
            'video',
            '.p-top__field-content'
        ];

        elements.forEach(selector => {
            const element = document.querySelector(selector);
            if (element) {
                element.style.opacity = 0;
                // 初期位置を設定（必要に応じて調整）
                gsap.set(selector, { y: 0 });
            }
        });
    }

    // initAnimations 関数の定義
    function initAnimations() {
        gsap.timeline({
            delay: -1.5, // タイムライン全体の開始を1秒遅らせる
            duration: 1.5, // タイムライン全体の duration
        })
        .fromTo('.p-fv__message-txt01-black', 
            { y: 20, opacity: 0 }, // アニメーション開始時の状態
            { y: 0, opacity: 1, duration: 0.8, ease: "ease.out" }
        )
        .fromTo('.p-fv__message-txt01-white', 
            { y: 20, opacity: 0 }, // アニメーション開始時の状態
            { y: 0, opacity: 1, duration: 0.8, ease: "ease.out" }
        )
        .fromTo('.p-fv__color-bar', 
            { opacity: 0 }, // アニメーション開始時の状態
            { opacity: 1, duration: 0.8, ease: "ease.out", delay: 0.2 }
        )
        .fromTo('.p-fv__message-splide-box', 
            { opacity: 0 }, // アニメーション開始時の状態
            { opacity: 1, duration: 0.1, ease: "ease.out", delay: 0.2, onStart: () => {
                // アニメーション開始時に mix-blend-mode を設定
                document.querySelector('.p-fv__message-splide-box').style.mixBlendMode = 'overlay';
            }}
        )
        .fromTo('video', 
            { opacity: 0 }, // アニメーション開始時の状態
            { opacity: 1, duration: 0.6, ease: "ease.out", delay: 0.2 }
        )
        .fromTo('.p-top__field-content', 
            { opacity: 0 }, // アニメーション開始時の状態
            { opacity: 1, duration: 0.6, ease: "ease.out", delay: 0.2 }
        );
    }

    // DOM が完全に読み込まれてから実行
    document.addEventListener('DOMContentLoaded', () => {
        setInitialState(); // 初期状態を設定

        const loadingElement = document.querySelector('.loading');
        if (loadingElement) {
            loadingElement.addEventListener('animationend', (event) => {
                if (event.animationName === 'fadeOut') { // 'fadeOut' は .loading のアニメーション名です
                    initAnimations(); // アニメーション完了時に initAnimations 関数を実行
                }
            });
        } else {
            console.warn('Loading element not found');
        }
    });
}

// 関数を初期化
fv();
